import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Dropdown from '@mlb/react-patterns/components/Dropdown/dropdown';

const selectEvents = [
    'create-option',
    'select-option',
    'set-value',
];
const deselectEvents = [
    'clear',
    'deselect-option',
    'pop-value',
    'remove-value',
];

export const Select = styled(Dropdown)`
  padding-bottom: 10px;
`;

const SingleSelect = (props) => {

    const {
        fields,
        onChange,
    } = props;

    const {
        options,
        selected,
        ...field
    } = fields[0];

    const normalizedHandlers = {
        onChange: (data) => {

            /** Normalize selected to be an array */
            const { selected, event } = data;

            const normalizedEvent = selectEvents.some((selectEvent) => {

                return selectEvent === event;

            })  ? 'select'
                : 'deselect';

            const normalizedData = {
                ...data,
                selected: [selected],
                event: normalizedEvent,
            };

            onChange(normalizedData, field);

        },
    };

    return (
        <Select
            multiple={false}
            handlers={normalizedHandlers}
            options={options}
            selected={selected}
        />
    );

};

SingleSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            options: PropTypes.array.isRequired,
            selected: PropTypes.array.isRequired,
        }).isRequired
    ).isRequired,
};

export default SingleSelect;
